// LIBRARIES //
import MediaQuery from 'react-responsive';
import React from 'react';
import styled from 'styled-components';
import range from 'lodash/range';

// COMPONENTS //
import Select from 'components/ui/SelectField';
import TextBox from 'components/ui/TextBox';
import Spacer from 'components/ui/Spacer';
import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';

const FullWidthInput = styled(TextBox)`
  width: 100%;
`;

const FullWidthSelect = styled(Select)`
  width: 100%;
`;

const StyledFormItem = styled(Form.Item)`
  .ant-form-item-label {
    padding-bottom: 0px;
  }
`;

export const GoogleReviewDialogContent = ({
  minimumLandlordRating,
  disableConfirmation,
  handleChange,
  values,
  setRatingValue,
  errors,
  touched,
}) => {
  if (!disableConfirmation) {
    return (
      <React.Fragment>
        <EnableFormVerbiage />
        <MinimumRatingInput
          minimumLandlordRating={minimumLandlordRating}
          values={values}
          handleChange={handleChange}
          setRatingValue={setRatingValue}
        />
        <URLTextInput
          values={values}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
        />
      </React.Fragment>
    );
  }

  return <DisableFormVerbiage />;
};

const DisableFormVerbiage = () => (
  <Spacer mb={1.7}>
    <Row gutter={16}>
      <Col span={24} style={{ marginTop: '10px' }}>
        {getTranslatedString('landlordPortal.properties.googleReviewsDialog.disableDescription')}
      </Col>
    </Row>
  </Spacer>
);

const EnableFormVerbiage = () => (
  <Spacer mb={1.7}>
    <Row gutter={16}>
      <MediaQuery query="(min-device-width: 750px)">
        <Col span={24} style={{ padding: '0px 8px 0px' }}>
          {getTranslatedString('landlordPortal.properties.googleReviewsDialog.description')}
        </Col>
      </MediaQuery>
      <MediaQuery query="(max-device-width: 750px)">
        <Col span={24}>
          {getTranslatedString('landlordPortal.properties.googleReviewsDialog.description')}
        </Col>
      </MediaQuery>
    </Row>
    <Row gutter={16}>
      <Col span={24} style={{ marginTop: '10px' }}>
        {getTranslatedString('landlordPortal.properties.googleReviewsDialog.info')}
      </Col>
    </Row>
  </Spacer>
);

const MinimumRatingInput = ({ minimumLandlordRating, values, handleChange, setRatingValue }) => (
  <Spacer mb={1}>
    <Row gutter={16}>
      <Col span={24}>
        <StyledFormItem
          label={getTranslatedString(
            'landlordPortal.properties.googleReviewsDialog.minimumRatingSelection'
          )}
        >
          <FullWidthSelect
            name="google_reviews_minimum_rating"
            value={values.google_reviews_minimum_rating}
            onChange={(value) => setRatingValue(value)}
            size="large"
          >
            {range(minimumLandlordRating, 11).map((rating) => (
              <Select.Option value={rating}>{`${rating} / 10`}</Select.Option>
            ))}
          </FullWidthSelect>
        </StyledFormItem>
      </Col>
    </Row>
  </Spacer>
);

const URLTextInput = ({ values, handleChange, errors, touched }) => (
  <Spacer mb={1}>
    <Row gutter={16}>
      <Col span={24}>
        <StyledFormItem
          label={getTranslatedString('landlordPortal.properties.googleReviewsDialog.link')}
          validateStatus={touched.google_review_link && errors.google_review_link && 'error'}
          help={touched.google_review_link && errors.google_review_link}
        >
          <FullWidthInput
            name="google_review_link"
            value={values.google_review_link}
            onChange={handleChange}
            size="large"
          />
        </StyledFormItem>
      </Col>
    </Row>
  </Spacer>
);
